/**
 * Match `/shop/:slug` to the same Category records the API uses for GET /products?category=…
 * shop/client often passes a slug from GET /categories (tree), not a hard-coded "women" string.
 */

/** URL segments → acceptable category slugs in DB (first tree match wins). */
const DEPARTMENT_SLUG_ALIASES = {
  women: ['women', 'womens', 'womenswear', 'womens-wear', 'womens-clothing', 'womens-clothing-edit'],
  men: ['men', 'mens', 'menswear', 'mens-wear'],
  accessories: ['accessories', 'accessory', 'acc'],
  tailoring: ['tailoring'],
  lounge: ['lounge'],
  outerwear: ['outerwear'],
  knitwear: ['knitwear'],
  dresses: ['dresses', 'dress', 'evening'],
};

function collectSlugCandidates(segment) {
  const seg = String(segment || '').toLowerCase().trim();
  const set = new Set([seg]);
  const aliases = DEPARTMENT_SLUG_ALIASES[seg];
  if (aliases) for (const a of aliases) set.add(a);
  return [...set];
}

/**
 * BFS walk category tree: { slug?, _id?, children?[] }
 * @param {unknown[]} roots
 * @param {string} segment - e.g. "women"
 * @returns {object | null}
 */
export function findCategoryNodeForShopSlug(roots, segment) {
  if (!Array.isArray(roots) || roots.length === 0 || !segment) return null;
  const candidates = collectSlugCandidates(segment);
  const candidateSet = new Set(candidates.map((s) => s.toLowerCase()));

  const stack = [...roots];
  while (stack.length) {
    const n = stack.shift();
    if (!n || typeof n !== 'object') continue;
    const slug = String(n.slug || '').toLowerCase();
    if (slug && candidateSet.has(slug)) return n;
    const ch = n.children;
    if (Array.isArray(ch)) for (const c of ch) stack.push(c);
  }
  return null;
}
